import ConfirmationBox from './ConfirmationBox';

export default ConfirmationBox;
